<p-dialog
    [visible]="isVisible()"
    (visibleChange)="toggleVisibility()"
    header="Export Data"
    [modal]="true"
    [style]="{ width: '90vw', maxWidth: '1200px', height: '85vh' }"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [maximizable]="true"
    styleClass="export-manager">

    <div class="my-3">
        <mat-accordion>
            <mat-expansion-panel [expanded]="showInstructions()">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="pi pi-info-circle text-blue-500 me-1"></i>
                        Export Options Guide
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="content p-3">
                    <div class="instruction-grid d-grid">
                        <div class=" d-flex align-items-start">
                            <div class="instruction-icon d-flex align-items-center justify-content-center">
                                <mat-icon>download</mat-icon>
                            </div>
                            <div class="instruction-text">
                                <strong>Choose Export Scope</strong>
                                <p>Select whether to export all data, filtered results, or only selected records</p>
                            </div>
                        </div>
                        
                        <div class="instruction-item">
                            <div class="instruction-icon">
                                <mat-icon>calculate</mat-icon>
                            </div>
                            <div class="instruction-text">
                                <strong>Include Aggregates</strong>
                                <p>Add summary rows with totals, averages, and counts to your export</p>
                            </div>
                        </div>
                        
                        <div class="instruction-item">
                            <div class="instruction-icon">
                                <mat-icon>visibility</mat-icon>
                            </div>
                            <div class="instruction-text">
                                <strong>Preview Your Data</strong>
                                <p>Review the first few rows before exporting to ensure accuracy</p>
                            </div>
                        </div>
                        
                        <div class="instruction-item">
                            <div class="instruction-icon">
                                <mat-icon>settings</mat-icon>
                            </div>
                            <div class="instruction-text">
                                <strong>Advanced Options</strong>
                                <p>Configure column headers, separators, and formatting preferences</p>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="export-manager-content">
        <!-- Export Context Summary -->
        <div class="context-summary mb-4">
            <mat-card class="stats-card">
                <mat-card-content>
                    <div class="stats-grid d-grid">
                        <div class="stat-item">
                            <div class="stat-icon">
                                <mat-icon class="text-primary">storage</mat-icon>
                            </div>
                            <div class="stat-content">
                                <div class="stat-value">{{ exportStats().totalRecords }}</div>
                                <div class="stat-label">Total Records</div>
                            </div>
                        </div>
                        @if(exportStats().hasActiveFilters) {
                            <div class="stat-item stat-filtered">
                                <div class="stat-icon">
                                    <mat-icon class="text-blue-600">filter_list</mat-icon>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value text-primary">
                                        {{ exportStats().filteredRecords }}
                                    </div>
                                    <div class="stat-label">Filtered Records</div>
                                </div>
                            </div>
                        }
                        @if(exportStats().selectedRecords > 0) {
                            <div class="stat-item stat-selected">
                                <div class="stat-icon">
                                    <mat-icon class="text-green-600">check_circle</mat-icon>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value text-success">
                                        {{ exportStats().selectedRecords }}
                                    </div>
                                    <div class="stat-label">Selected Records</div>
                                </div>
                            </div>
                        }
                        <div class="stat-item">
                            <div class="stat-icon">
                                <mat-icon class="text-orange-600">view_column</mat-icon>
                            </div>
                            <div class="stat-content">
                                <div class="stat-value">{{ exportStats().visibleColumns }}</div>
                                <div class="stat-label">Columns to Export</div>
                            </div>
                        </div>

                        @if(exportStats().hasAggregates) {
                            <div class="stat-item stat-aggregates">
                                <div class="stat-icon">
                                    <mat-icon class="text-purple-600">functions</mat-icon>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value">
                                        <i class="pi pi-check text-success"></i>
                                    </div>
                                    <div class="stat-label">Aggregates Available</div>
                                </div>
                            </div>
                        }
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- Export Controls -->
        <app-lt-export-controls 
            [exportStats]="exportStats()"
            [exportOptions]="exportOptions()"
            (optionsChange)="onOptionsChange($event)"
            (scopeChange)="onScopeChange($event)"
            (exportRequested)="onExportRequested($event)">
        </app-lt-export-controls>

        <!-- Export Configuration -->
        @if(showAdvancedConfig()) {
            <div class="mt-3">
                <app-lt-export-config
                    [showAdvanced]="showAdvancedConfig()"
                    [exportOptions]="exportOptions()"
                    (optionsChange)="onOptionsChange($event)">
                </app-lt-export-config>
            </div>
        }

        <!-- Export Preview -->
        @if(showPreview()) {
            <div class="mt-3">
                <app-lt-export-preview
                    [showPreview]="showPreview()"
                    [exportStats]="exportStats()"
                    [exportOptions]="exportOptions()"
                    [exportManagerFacade]="exportManagerFacade"
                    [selectedScope]="selectedExportScope()"
                    [columns]="gridFacade().getVisibleColumns()"
                    class="mt-4">
                </app-lt-export-preview>
            </div>
        }

        <!-- Export Status -->
        @if(isExporting()) {
            <div class="export-status mt-3">
                <mat-card class="status-card">
                    <mat-card-content>
                        <div class="d-flex align-items-center gap-3">
                            <p-progressSpinner 
                                [style]="{ width: '30px', height: '30px' }"
                                strokeWidth="4">
                            </p-progressSpinner>
                            <div>
                                <strong>Exporting data...</strong>
                                <p class="mb-0 text-muted">Please wait while your data is being exported</p>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        }
    </div>

    <!-- Dialog Footer -->
    <ng-template pTemplate="footer">
        <div class="footer-layout d-flex justify-content-between w-100">
            <div class="footer-left d-flex gap-2">
                <p-button
                    [label]="showPreview() ? 'Hide Preview' : 'Show Preview'"
                    [icon]="showPreview() ? 'pi pi-eye-slash' : 'pi pi-eye'"
                    styleClass="p-button-text"
                    (onClick)="togglePreview()"
                    [disabled]="isExporting()">
                </p-button>

                <p-button
                    [label]="showAdvancedConfig() ? 'Hide Advanced' : 'Advanced Options'"
                    [icon]="showAdvancedConfig() ? 'pi pi-chevron-up' : 'pi pi-cog'"
                    styleClass="p-button-text"
                    (onClick)="toggleAdvancedConfig()"
                    [disabled]="isExporting()">
                </p-button>

                <p-button
                    label="Help"
                    icon="pi pi-question-circle"
                    styleClass="p-button-text"
                    (onClick)="showInstructions.set(!showInstructions())"
                    [disabled]="isExporting()">
                </p-button>
            </div>
            
            <div class="footer-right d-flex gap-2">
                <p-button
                    label="Cancel"
                    icon="pi pi-times"
                    styleClass="p-button-text p-button-secondary"
                    (onClick)="cancel()"
                    [disabled]="isExporting()">
                </p-button>
                
                <p-button
                    label="Export Data"
                    icon="pi pi-download"
                    [disabled]="!canExport() || isExporting()"
                    [loading]="isExporting()"
                    (onClick)="executeExport()">
                </p-button>
            </div>
        </div>
    </ng-template>

</p-dialog>